import { render, staticRenderFns } from "./DongLingHome.vue?vue&type=template&id=264d5fba&scoped=true"
import script from "./DongLingHome.vue?vue&type=script&lang=js"
export * from "./DongLingHome.vue?vue&type=script&lang=js"
import style0 from "./DongLingHome.vue?vue&type=style&index=0&id=264d5fba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264d5fba",
  null
  
)

export default component.exports